import actionCreatorFactory from 'typescript-fsa';
import * as constants from './constants';
import {User} from '../../../api/api';

const actionCreator = actionCreatorFactory('users');

export const getUsersAction = actionCreator.async<any, User[]>(constants.constants.GET_USERS);
